import React, { memo } from 'react';
import { Text } from 'core/components';
import { inject } from 'mobx-react';
import Markdown from '../../journeys/Markdown';
import { MessageItem, UserMessageBubble, MessageHeader, Timestamp } from '../KaizenChatSession.styles';

const userPromptRegex = /User prompt:\s*(.*?)$/s;

const extractUserPrompt = (messageText) => {
  // Regex to match everything after "User prompt: " until the end of the string
  const match = messageText.match(userPromptRegex);

  // If we find a match, return the extracted prompt, otherwise return the original message
  return match ? match[1].trim() : messageText;
};

// Memoized user message component
const UserMessage = memo(({ message, formatDate }) => {
  // Check if the message contains context (regex matched)
  const displayText = extractUserPrompt(message.message_text);

  return (
    <MessageItem key={`user-${message.id}`}>
      <UserMessageBubble>
        <MessageHeader isUser>
          <Text>{message.user?.user_full_name || 'User'}</Text>
          <Timestamp isUser>{formatDate(message?.created_at || new Date())}</Timestamp>
        </MessageHeader>
        <Markdown>{displayText}</Markdown>
      </UserMessageBubble>
    </MessageItem>
  );
});

UserMessage.displayName = 'UserMessage';

export default inject('$auth')(UserMessage);
